export const TIME_FORMAT = 'HH:mm';
export const SELECTED_TIME = /00:00/;
